import { handleMenu } from "./ActionsCreators";

export const handleToggleMenu = () => {

	return dispatch => {
		dispatch(handleMenu());
	};
};
